"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MILLIS_PER_SECOND = 1000;
exports.SECONDS_PER_DAY = 86400;
exports.SECONDS_PER_HOUR = 3600;
exports.SECONDS_PER_MINUTE = 60;
exports.MINUTES_PER_HOUR = 60;
exports.HOURS_PER_DAY = 24;
exports.SPEED = {
    slow: '600',
    medium: '300',
    fast: '150',
};
exports.DELAY = {
    short: '500',
    medium: '1000',
    long: '1500',
};
